import React from 'react';
import { NavLink } from 'react-router-dom';
import { HorizontalMenu } from '../../../../shared/horizontal-menu/HorizontalMenu';
import ShowIfPermission from '../../../../shared/show-if-permission/ShowIfPermission';
import { PermissionEnum } from '../../../../shared/models/permissions';
import { isComparisonEnabled } from '../../../../shared/feature-flags';
import { SimulationPath } from '../simulation.paths';
import './simulation.scss';

const startsWith = prefixes => (match, location) =>
    prefixes.some(prefix => location.pathname.indexOf(prefix) === 0);

/* The runs are at /simulations, /simulations/new and /simulations/<id>: everything that is not one of the other sections. */
const isRunsSection = (match, location) =>
    !startsWith([
        SimulationPath.WORKSPACES,
        SimulationPath.TEST_CHANGE,
        '/simulations/comparisons'
    ])(match, location);

/* The frame of every simulation screen: the sections of the simulation, and who may see it. */
export const SimulationLayout = ({ children }) => (
    <ShowIfPermission permission={PermissionEnum.MANAGE_SIMULATIONS}>
        <div className={'container simulation'}>
            <HorizontalMenu>
                <NavLink
                    className="horizontal-menu-item"
                    to={SimulationPath.RUNS}
                    isActive={isRunsSection}
                >
                    Runs
                </NavLink>
                <NavLink
                    className="horizontal-menu-item"
                    to={SimulationPath.WORKSPACES}
                    isActive={startsWith([SimulationPath.WORKSPACES])}
                >
                    Sandboxes
                </NavLink>
                {isComparisonEnabled() && (
                    <NavLink
                        className="horizontal-menu-item"
                        to={SimulationPath.TEST_CHANGE}
                        isActive={startsWith([
                            SimulationPath.TEST_CHANGE,
                            '/simulations/comparisons'
                        ])}
                    >
                        Test a change
                    </NavLink>
                )}
            </HorizontalMenu>
            <div className={'simulation-content'}>{children}</div>
        </div>
    </ShowIfPermission>
);

/* Makes a screen one of the simulation: inside the frame of it, with the props of the route passed on. */
export const inSimulation = Screen => props => (
    <SimulationLayout>
        <Screen {...props} />
    </SimulationLayout>
);
